import { render } from "./RecursiveListCollection.vue?vue&type=template&id=04d825a8&scoped=true&ts=true"
import script from "./RecursiveListCollection.vue?vue&type=script&lang=ts"
export * from "./RecursiveListCollection.vue?vue&type=script&lang=ts"

import "./RecursiveListCollection.vue?vue&type=style&index=0&id=04d825a8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d825a8"]])

export default __exports__